import React, { Fragment, useState, useEffect, useRef } from "react";
import { Card, Tabs, Button, Select, Spin, Table } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { NotificationManager } from "react-notifications";
import GlobalFilterDrawer from "../../../components/GlobalFilterDrawer";
import CustomerTab from "./PaymentTabs/CustomerTab";
import CustomerAgingTbl from "./PaymentTabs/CustomerAgingTbl";
import InvoiceDetailsTbl from "./PaymentTabs/InvoiceDetailsTbl";
import {
  imgBank,
  imgFilter,
  paymentSmall_1,
  paymentSmall_2,
  paymentSmall_3,
  paymentSmall_4,
} from "../imageAssets";
import paymentService from "../../../services/Payment/payment-service";
import eliteCardService from "../../../services/elite-cards-service";
import InvoiceOutstandingBarChart from "./PaymentTabs/InvoiceOutstandingBarChart";
import formatNumber from "../../../utils/formatNumber";
import { PayloadForApplyFilterData } from "../../../components/PayloadForApplyFilterData";
import {
  setPaymentTableFilter,
  setSelectedCustomerData,
} from "../../../actions/paymentTableFilter/paymentTableFilterAction";

const { TabPane } = Tabs;
const { Option } = Select;

const PaymentDashboard = () => {
  const isFirstRender = useRef(true);
  const isSecondRender = useRef(true);
  const isThirdRender = useRef(false);
  const dispatch = useDispatch();
  const companyDetails = useSelector(
    (state) => state.CompanyDetails.companyDetials
  );

  const userDetails = useSelector(
    (state) => state.loginReducer.loginDetials.userDetails
  );

  const selectedCustomerAgingData = useSelector(
    (state) => state.PaymentTableFilter.selectedRow
  );

  const globalFilters = useSelector(
    (state) => state.GlobalFilters.globalFilterSapCodes
  );

  const selectedCustomerData = useSelector(
    (state) => state.PaymentTableFilter.selectedCustomerData
  );

  const [isLoading, setIsLoading] = useState(false);
  const [customerAgingLoading, setCustomerAgingLoading] = useState(false);
  const [isGlobalFilter, setIsGlobalFilter] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [applyFilterObj, setApplyFilterObj] = useState(globalFilters || {});
  const [selectAnalysisType, setSelectAnalysisType] = useState(
    userDetails.isEmployee ? "T" : "C"
  );
  const [invoiceOutStandingData, setInvoiceOutStandingData] = useState([]);
  const [customerAgingData, setCustomerAgingData] = useState([]);
  const [invoiceDetailsData, setInvoiceDetailsData] = useState([]);
  const [totalAmountLCYCount, setTotalAmountLCYCount] = useState(0);
  const [totalActualAmt, setTotalActualAmt] = useState(0);
  const [currency, setCurrency] = useState("");
  const [tableObjColumn, setTableObjColumn] = useState({
    sortColumn: "",
    orderBy: "",
    currentPage: "",
    table: "",
    isPaginationSorting: false,
  });
  const [distributionChannelData, setDistributionChannelData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [priceGroupData, setPriceGroupData] = useState([]);
  const [salesOfficeData, setSalesOfficeData] = useState([]);
  const [selectedDistributionIds, setSelectedDistributionIds] = useState([]);
  const [selectedCountryIds, setSelectedCountryIds] = useState([]);
  const [selectedPriceGroupIds, setSelectedPriceGroupIds] = useState([]);
  const [selectedSalesOfficeIds, setSelectedSalesOfficeIds] = useState([]);
  const [isSelectDistributionAll, setIsSelectDistributionAll] = useState(false);
  const [isSelectCountryAll, setIsSelectCountryAll] = useState(false);
  const [isSelectPriceGroupAll, setIsSelectPriceGroupAll] = useState(false);
  const [isSelectSalesOfficeAll, setIsSelectSalesOfficeAll] = useState(false);
  const [selectedBarFilter, setSelectedBarFilter] = useState([]);
  const [yearsData, setYearsData] = useState([]);
  const [selectYears, setSelectYears] = useState(null);
  const [selectQuater, setSelectQuater] = useState(null);
  const [customerOutstandingAvg, setCustomerOutstandingAvg] = useState({});
  const [customerUtilization, setCustomerUtilization] = useState({});
  const [isOutStandingLoading, setIsOutStandingLoading] = useState(false);
  const [isDashboardLoading, setIsDashboardLoading] = useState(false);
  const [dashboardCounts, setDashboardCounts] = useState({});
  const [selectedCompany, setSelectedCompany] = useState(
    companyDetails?.company_Code || ""
  );

  useEffect(() => {
    let CompanyCode = localStorage.getItem("Company_Code");
    if (selectedCompany !== CompanyCode) {
      isSecondRender.current = true;
      setSelectedCompany(CompanyCode);
      dispatch(setPaymentTableFilter(""));
      dispatch(setSelectedCustomerData(""));
      localStorage.setItem("selectedAnalysisType", "C");
      setSelectAnalysisType("C");
      setSelectedBarFilter([]);
      setApplyFilterObj({});
      setTableObjColumn({
        sortColumn: "",
        orderBy: "desc",
        currentPage: "",
        table: "",
      });
    }
  }, [companyDetails]);

  useEffect(() => {
    let CompanyCode = localStorage.getItem("Company_Code");
    if (isSecondRender.current) {
      setTimeout(() => {
        handleGetPaymentDashboardCount();
        handleGetDistributionchannelData();
        handleGetCountryData();
        handleGetPriceGroupData();
        handleGetSalesOfficeData();
        handleGetCustomerAgingDetailsAPI();
        handleGetInvoiceDetailsAPI();
        handleGetPaymentTileCount();
        handleFetchYearsDataAPI();
        handleGetCustomerInvoiceOutstandingData();
      }, 500);
      isSecondRender.current = false;
    }
    if (
      Object.keys(applyFilterObj).length > 0 &&
      selectedCompany === CompanyCode
    ) {
      // handleGetPaymentTileCount();
      // handleGetCustomerInvoiceOutstandingData();
      // handleGetCustomerAgingDetailsAPI();
      // handleGetInvoiceDetailsAPI();
      // handleGetPaymentDashboardCount();
      OnResetSelectedFilter();
    }
  }, [applyFilterObj, companyDetails]);

  useEffect(() => {
    if (isThirdRender.current) {
      handleGetPaymentDashboardCount();
      handleGetDistributionchannelData();
      handleGetCountryData();
      handleGetPriceGroupData();
      handleGetSalesOfficeData();
      handleGetCustomerAgingDetailsAPI();
      handleGetInvoiceDetailsAPI();
      handleGetPaymentTileCount();
      handleFetchYearsDataAPI();
      handleGetCustomerInvoiceOutstandingData();
      isThirdRender.current = false;
    }
  }, [isThirdRender.current]);

  useEffect(() => {
    let selectedAnalysisType = localStorage.getItem("selectedAnalysisType");
    // setTimeout(() => {
    if (selectAnalysisType !== selectedAnalysisType) {
      localStorage.setItem("selectedAnalysisType", selectAnalysisType);
      if (selectAnalysisType !== "R") {
        handleFetchYearsDataAPI();
        handleGetPaymentDashboardCount();
        handleGetPaymentTileCount();
        handleGetCustomerInvoiceOutstandingData();
      }
      handleGetInvoiceDetailsAPI();
      handleGetCustomerAgingDetailsAPI();
    }
    // }, 300);
  }, [selectAnalysisType]);

  useEffect(() => {
    setIsEmployee(userDetails.isEmployee);
    const { table, isPaginationSorting } = tableObjColumn;
    if (table) {
      if (table === "Customer Aging") {
        if (isPaginationSorting) {
          handleGetCustomerAgingDetailsAPI();
          handleGetInvoiceDetailsAPI();
        } else {
          handleGetCustomerAgingDetailsAPI();
        }
      } else {
        handleGetInvoiceDetailsAPI();
      }
    }
    // else {
    //   handleGetPaymentTileCount();
    //   handleGetCustomerAgingDetailsAPI();
    //   handleGetInvoiceDetailsAPI();
    //   handleGetPaymentDashboardCount();
    //   handleGetCustomerInvoiceOutstandingData();
    // }
    if (isFirstRender.current) {
      isFirstRender.current = false;
      localStorage.setItem("selectedAnalysisType", "C");
    }

    //////--------------Don't uncomment these code ------------------------
    //  if (
    // Object.keys(applyFilterObj).length > 0 ||
    // selectedCustomerAgingData ||
    // selectAnalysisType !== selectedAnalysisType
    // selectedDistributionIds.length > 0 ||
    // selectedCountryIds.length > 0 ||
    // selectedPriceGroupIds.length > 0 ||
    // selectedSalesOfficeIds.length > 0 ||
    // selectYears?.length > 0 ||
    // selectQuater?.length > 0
    // selectedBarFilter.length > 0
    // )else {
    //   setTimeout(() => {
    //     handleFetchYearsDataAPI();
    //     handleGetPaymentDashboardCount();
    //     handleGetPaymentTileCount();
    //     handleGetCustomerInvoiceOutstandingData();
    //     handleGetInvoiceDetailsAPI();
    //     handleGetCustomerAgingDetailsAPI();
    //   }, 300);
    // }
    if (selectYears?.length > 0 || selectQuater?.length > 0) {
      setTimeout(() => {
        // handleFetchYearsDataAPI();
        // handleGetPaymentDashboardCount();
        // handleGetPaymentTileCount();
        handleGetCustomerInvoiceOutstandingData();
        // handleGetInvoiceDetailsAPI();
        // handleGetCustomerAgingDetailsAPI();
      }, 300);
    }
  }, [
    selectAnalysisType,
    selectedDistributionIds,
    selectedCountryIds,
    selectedPriceGroupIds,
    selectedSalesOfficeIds,
    selectedBarFilter,
    tableObjColumn,
    selectYears,
    selectQuater,
    selectedCustomerAgingData,
    companyDetails,
    applyFilterObj,
  ]);

  //// handle Apply filter code
  const handleApplyFilter = (objData) => {
    setApplyFilterObj(objData);
  };
  /// show Filter Drawer code
  const showFilterDrawer = () => {
    setDrawerOpen((prevDrawerOpen) => !prevDrawerOpen);
    setIsGlobalFilter(!isGlobalFilter);
  };
  const CloseFilterDrawer = () => {
    setDrawerOpen(false);
    setIsGlobalFilter(false);
  };
  //// ---------------API Calling Function code start
  //// handle set params
  const handleAPIParams = (check) => {
    let CompanyCode = localStorage.getItem("Company_Code");
    const inputData = {
      company_Code: companyDetails ? companyDetails.company_Code : "",
      ...(check === "Aging" ||
      check === "Invoice" ||
      check === "Years" ||
      check === "counts" ||
      check === "graph"
        ? { type: selectAnalysisType }
        : {}),
      sortcolumn:
        check === "Invoice"
          ? "invoiceDate"
          : tableObjColumn !== ""
          ? tableObjColumn?.sortColumn
          : "",
      orderBy:
        check === "Invoice"
          ? "asc"
          : // : check === "Aging"
          // ? tableObjColumn.orderBy
          tableObjColumn.orderBy !== ""
          ? tableObjColumn?.orderBy
          : "desc",
      distributionChannel: selectedDistributionIds.join(","),
      country: selectedCountryIds.join(","),
      priceGroup: selectedPriceGroupIds.join(","),
      salesOffice: selectedSalesOfficeIds.join(","),
      search:
        selectedCompany !== localStorage.getItem("Company_Code")
          ? ""
          : selectedBarFilter && selectedBarFilter.length > 0
          ? selectedBarFilter.map((item) => item.customerId).join(",")
          : selectedCustomerAgingData
          ? selectedCustomerAgingData
          : "",
      ...(check === "graph"
        ? {
            pageindex: "",
            pagesize: "",
            year: selectYears ? selectYears : null,
            quarter:
              selectQuater === "all"
                ? null
                : selectQuater
                ? selectQuater
                : null,
          }
        : {
            // pageindex:
            //   tableObjColumn.currentPage !== ""
            //     ? tableObjColumn.currentPage.toString()
            //     : "1",
            pagesize:
              check === "Invoice"
                ? selectedCustomerData?.length > 0 &&
                  selectedCompany === CompanyCode
                  ? "700"
                  : "50"
                : "10",
          }),
      distributionChannel: selectedDistributionIds
        ? selectedDistributionIds.join(",")
        : "",
      salesOffice: selectedSalesOfficeIds
        ? selectedSalesOfficeIds.join(",")
        : "",
      priceGroup: selectedPriceGroupIds ? selectedPriceGroupIds.join(",") : "",
      ...PayloadForApplyFilterData(
        selectedCompany !== localStorage.getItem("Company_Code")
          ? {}
          : applyFilterObj,
        companyDetails
      ),
    };
    if (isGlobalFilter) {
      showFilterDrawer();
    }
    return inputData;
  };

  /// Get payment dashboard counts API
  const handleGetPaymentDashboardCount = () => {
    setIsDashboardLoading(true);
    let inputData = {
      pageindex:
        tableObjColumn.currentPage !== ""
          ? tableObjColumn.currentPage.toString()
          : "1",
      ...handleAPIParams("counts"),
    };

    paymentService
      .getPaymentDashboardCountAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finaldata = response.data.responseData;
          if (Object.keys(finaldata).length > 0) {
            setDashboardCounts(finaldata);
          } else {
            setDashboardCounts({});
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        setIsDashboardLoading(false);
        console.log(error, "Error");
      })
      .finally(() => {
        setIsDashboardLoading(false);
      });
  };
  /// Get Customer And Currency Wise Outstanding listing API
  const handleGetCustomerInvoiceOutstandingData = () => {
    setIsOutStandingLoading(true);
    let inputData = handleAPIParams("graph");
    paymentService
      .getPaymentCustomerOutstandingGraphAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finaldata = response.data.responseData;
          if (finaldata.customerOutstandings?.length > 0) {
            setInvoiceOutStandingData(finaldata.customerOutstandings);
            setCustomerOutstandingAvg(finaldata.customerOutstandingAvg);
            setCustomerUtilization(finaldata.customerUtilization);
          } else {
            setInvoiceOutStandingData([]);
            setCustomerOutstandingAvg({});
            setCustomerUtilization({});
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        setIsOutStandingLoading(false);
        console.log(error, "Error");
      })
      .finally(() => {
        setIsOutStandingLoading(false);
      });
  };
  /// Get Customer Aging Details listing API
  const handleGetCustomerAgingDetailsAPI = () => {
    setCustomerAgingLoading(true);
    let CompanyCode = localStorage.getItem("Company_Code");
    let inputData = {
      pageindex:
        tableObjColumn.table == "Customer Aging"
          ? selectedCompany === CompanyCode
            ? tableObjColumn.currentPage.toString()
            : "1"
          : "1",
      ...handleAPIParams("Aging"),
    };

    paymentService
      .getPaymentCustomerAgeingDataAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finaldata = response.data.responseData;
          setCustomerAgingData(finaldata);
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        setCustomerAgingLoading(false);
        console.log(error, "Error");
      })
      .finally(() => {
        setCustomerAgingLoading(false);
      });
  };
  /// Get Invoice Details listing API
  const handleGetInvoiceDetailsAPI = () => {
    setIsLoading(true);
    let CompanyCode = localStorage.getItem("Company_Code");
    let inputData = {
      pageindex:
        tableObjColumn.table == "Invoice Details"
          ? selectedCompany === CompanyCode
            ? tableObjColumn.currentPage.toString()
            : "1"
          : "1",
      ...handleAPIParams("Invoice"),
    };
    paymentService
      .getPaymentInvoiceDataAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finaldata = response.data.responseData;
          const isReceivable = selectAnalysisType === "R";
          const invoiceList = isReceivable
            ? finaldata.customerInvoiceWiseList_Received
            : finaldata.customerInvoiceWiseList;
          if (invoiceList && invoiceList.length > 0) {
            let parentUniqueKeyCounter = 1;
            let childUniqueKeyCounter = 2000;

            let finalUpdatedData = invoiceList.map(
              (item) => {
                const childList = isReceivable
                  ? item.customerAgeingList_Received
                  : item.customerAgeingList;
                const updateChildren = (childList || []).map((child) => {
                  return {
                    uniqueKey: `child-${childUniqueKeyCounter++}`,
                    ...child,
                  };
                });

                return {
                  uniqueKey: `parent-${parentUniqueKeyCounter++}`,
                  ...item,
                  children: updateChildren,
                };
              }
            );

            let finalValue = {
              customerInvoiceList: finalUpdatedData,
              ...finaldata,
            };
            setTableObjColumn({
              sortColumn: "",
              orderBy: "desc",
              currentPage: "",
              table: "",
            });
            setInvoiceDetailsData(finalValue);
          } else {
            setInvoiceDetailsData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(error, "Error");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  //// handle get payment tile counts API
  const handleGetPaymentTileCount = () => {
    let inputData = {
      type: selectAnalysisType,
      ...PayloadForApplyFilterData(
        selectedCompany !== localStorage.getItem("Company_Code")
          ? {}
          : applyFilterObj,
        companyDetails
      ),
    };
    if (isGlobalFilter) {
      showFilterDrawer();
    }
    eliteCardService
      .getPaymentTileCountsAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let objData = response.data.responseData;
          if (Object.keys(objData).length > 0) {
            setTotalAmountLCYCount(
              objData.totalPendingAmount_LCY
                ? objData.totalPendingAmount_LCY
                : 0
            );
            setTotalActualAmt(
              objData.actualPendingAmountCount
                ? objData.actualPendingAmountCount
                : 0
            );
            setCurrency(objData.currency ? objData.currency : "");
          } else {
            setTotalAmountLCYCount(0);
            setTotalActualAmt(0);
            setCurrency("");
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };

  //// handle Get Distribution Channel API
  const handleGetDistributionchannelData = () => {
    paymentService
      .getDistributionchannelDataAPI()
      .then((response) => {
        if (response.data.statusCode === 200) {
          let resultData = response.data.responseData;
          if (resultData.length > 0) {
            setDistributionChannelData(resultData);
          } else {
            setDistributionChannelData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  //// handle Get Country Channel API
  const handleGetCountryData = () => {
    paymentService
      .getCountryDataAPI()
      .then((response) => {
        if (response.data.statusCode === 200) {
          let resultData = response.data.responseData;
          if (resultData.length > 0) {
            setCountryData(resultData);
          } else {
            setCountryData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  //// handle Get Price Group API
  const handleGetPriceGroupData = () => {
    paymentService
      .getPrinceGroupDataAPI()
      .then((response) => {
        if (response.data.statusCode === 200) {
          let resultData = response.data.responseData;
          if (resultData.length > 0) {
            setPriceGroupData(resultData);
          } else {
            setPriceGroupData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  //// handle Get Sales Office API
  const handleGetSalesOfficeData = () => {
    paymentService
      .getSalesOfficeDataAPI()
      .then((response) => {
        if (response.data.statusCode === 200) {
          let resultData = response.data.responseData;
          if (resultData.length > 0) {
            setSalesOfficeData(resultData);
          } else {
            setSalesOfficeData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  /// Fetch Years data listing API
  const handleFetchYearsDataAPI = () => {
    let inputData = handleAPIParams("Years");
    paymentService
      .getYearsDataAPI(inputData)
      .then((response) => {
        if (response.data.statusCode === 200) {
          let finaldata = response.data.responseData;
          if (finaldata.length > 0) {
            setYearsData(finaldata);
          } else {
            setYearsData([]);
          }
        } else {
          NotificationManager.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error, "Error");
      });
  };
  //// ---------------API Calling Function code end

  //// Analysis Type changes
  const handleAnalysisTypeChange = (e) => {
    setSelectAnalysisType(e);
    setTableObjColumn({
      sortColumn: "",
      orderBy: "desc",
      currentPage: "",
      table: "",
    });
  };

  //// handle select Bar chart data
  const handleSetSelectedBarChartData = (filter) => {
    if (filter?.length > 0) {
      if (!isThirdRender.current) {
        isThirdRender.current = true;
      }
    }

    if (filter?.length === 0) {
      if (!isThirdRender.current) {
        isThirdRender.current = true;
      }
    }
    setTableObjColumn({
      sortColumn: "",
      orderBy: "desc",
      currentPage: "",
      table: "",
      isPaginationSorting: true,
    });
    setSelectedBarFilter(filter);
  };
  //// table sorting column
  const handleTableSortColumn = (data) => {
    setTableObjColumn({
      sortColumn: data.sortColumn,
      orderBy: data.orderBy,
      currentPage: data.currentPage,
      table: data.table,
      isPaginationSorting: data.isPaginationSorting,
    });
    // isSecondRender.current = true;
  };

  //// handle drop-down Distribution channel select all and deselect all
  const handleDistributionOnChange = (value) => {
    if (value.includes("all")) {
      if (isSelectDistributionAll) {
        setSelectedDistributionIds([]);
        setIsSelectDistributionAll(false);
      } else {
        const allIds = distributionChannelData.map((item) => item.id);
        setSelectedDistributionIds(allIds);
        setIsSelectDistributionAll(true);
      }
    } else {
      setSelectedDistributionIds(value);
      setIsSelectDistributionAll(
        value.length === distributionChannelData.length
      );
    }
    handleDropdownOnchangeReset();
  };
  //// handle drop-down Country channel select all and deselect all
  const handleCountryOnChange = (value) => {
    if (value.includes("all")) {
      if (isSelectCountryAll) {
        setSelectedCountryIds([]);
        setIsSelectCountryAll(false);
      } else {
        const allIds = countryData.map((item) => item.id);
        setSelectedCountryIds(allIds);
        setIsSelectCountryAll(true);
      }
    } else {
      setSelectedCountryIds(value);
      setIsSelectCountryAll(value.length === countryData.length);
    }
    handleDropdownOnchangeReset();
  };
  //// handle drop-down Price group select all and deselect all
  const handlePriceGroupOnChange = (value) => {
    if (value.includes("all")) {
      if (isSelectPriceGroupAll) {
        setSelectedPriceGroupIds([]);
        setIsSelectPriceGroupAll(false);
      } else {
        const allIds = priceGroupData.map((item) => item.id);
        setSelectedPriceGroupIds(allIds);
        setIsSelectPriceGroupAll(true);
      }
    } else {
      setSelectedPriceGroupIds(value);
      setIsSelectPriceGroupAll(value.length === priceGroupData.length);
    }
    handleDropdownOnchangeReset();
  };
  //// handle drop-down Sales Office select all and deselect all
  const handleSalesOfficeOnChange = (value) => {
    if (value.includes("all")) {
      if (isSelectSalesOfficeAll) {
        setSelectedSalesOfficeIds([]);
        setIsSelectSalesOfficeAll(false);
      } else {
        const allIds = salesOfficeData.map((item) => item.id);
        setSelectedSalesOfficeIds(allIds);
        setIsSelectSalesOfficeAll(true);
      }
    } else {
      setSelectedSalesOfficeIds(value);
      setIsSelectSalesOfficeAll(value.length === salesOfficeData.length);
    }
    handleDropdownOnchangeReset();
  };
  //// handle drop down onChange
  const handleDropDownOnChange = (value, check) => {
    if (check === "year") {
      setSelectYears(value);
    } else {
      setSelectQuater(value);
    }
  };
  const handleDropdownOnchangeReset = () => {
    let CompanyCode = localStorage.getItem("Company_Code");
    setSelectedCompany(CompanyCode);
    dispatch(setPaymentTableFilter(""));
    dispatch(setSelectedCustomerData(""));
    localStorage.setItem("selectedAnalysisType", "C");
    setSelectAnalysisType("C");
    setSelectedBarFilter([]);
    setTableObjColumn({
      sortColumn: "",
      orderBy: "desc",
      currentPage: "",
      table: "",
    });
    // setTimeout(() => {
    isThirdRender.current = true;
    // }, 800);
  };
  const OnResetSelectedFilter = () => {
    let CompanyCode = localStorage.getItem("Company_Code");
    setSelectedCompany(CompanyCode);
    // dispatch(setPaymentTableFilter(""));
    // dispatch(setSelectedCustomerData(""));
    localStorage.setItem("selectedAnalysisType", "C");
    setSelectAnalysisType("C");
    setSelectedBarFilter([]);
    setSelectedDistributionIds([]);
    setSelectedCountryIds([]);
    setSelectedPriceGroupIds([]);
    setSelectedSalesOfficeIds([]);
    setIsSelectDistributionAll(false);
    setIsSelectPriceGroupAll(false);
    setIsSelectSalesOfficeAll(false);
    // setApplyFilterObj({});
    setTableObjColumn({
      sortColumn: "",
      orderBy: "desc",
      currentPage: "",
      table: "",
    });
    // setTimeout(() => {
    isThirdRender.current = true;
    // }, 500);
  };
  //// handle filter reset data with load default data
  const handleResetFilterData = () => {
    setTableObjColumn({
      sortColumn: "",
      orderBy: "desc",
      currentPage: "",
      table: "",
    });
    setSelectedDistributionIds([]);
    setSelectedCountryIds([]);
    setSelectedPriceGroupIds([]);
    setSelectedSalesOfficeIds([]);
    setIsSelectDistributionAll(false);
    setIsSelectPriceGroupAll(false);
    setIsSelectSalesOfficeAll(false);
    isThirdRender.current = true;
  };
  //// handle filter data exist code
  function hasFilterDataExist(obj) {
    return Object.values(obj).some((array) => array.length > 0);
  }

  return (
    <Fragment>
      <div className="app-content content paymentModule">
        <div className="content-wrapper">
          <div className="content-body">
            {hasFilterDataExist(applyFilterObj) && (
              <h5 className="appled_filter">Applied Filters</h5>
            )}
            <h5 className="content-header-title d-inline-block">Payment</h5>
            <div className="main-setting">
              <Button
                className={`setting-button ${drawerOpen ? "open" : ""}${
                  userDetails?.designation === "Director" &&
                  companyDetails?.company_Code !== "1000"
                    ? "filter_btn_dis"
                    : ""
                }`}
                icon={<SettingOutlined spin />}
                onClick={() => showFilterDrawer()}
                disabled={
                  userDetails?.designation === "Director" &&
                  companyDetails?.company_Code !== "1000"
                }
              />
            </div>
            <Spin size="large" spinning={isDashboardLoading}>
              <div className="row">
                <div className={"col-xl-3 col-lg-6 col-12"}>
                  <div className="card bg_info">
                    <div className="card-content">
                      <div className="card-body payment1 images_bg">
                        <h4 className="text-white font24">
                          <img
                            src={paymentSmall_1}
                            className="card_small_img"
                            alt="Img"
                            style={{ width: "14px" }}
                          />
                          <div className="tile_cards">
                            <span style={{ fontSize: "20px" }}>
                              Total Open Invoice
                            </span>
                            <label>
                              {isEmployee ? "INR " : currency + " "}
                              {Object.keys(dashboardCounts).length > 0 &&
                                formatNumber(dashboardCounts.totalInvoice)}
                            </label>
                          </div>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"col-xl-3 col-lg-6 col-12"}>
                  <div className="card bg_warning">
                    <div className="card-content">
                      <div className="card-body payment2 images_bg">
                        <h4 className="text-white font24">
                          <img
                            src={paymentSmall_2}
                            className="card_small_img"
                            alt="Img"
                          />
                          <div className="tile_cards">
                            <span style={{ fontSize: "20px", zIndex: 2 }}>
                              Total Received Value
                            </span>
                            <label>
                              {isEmployee ? "INR " : currency + " "}
                              {Object.keys(dashboardCounts).length > 0 &&
                                formatNumber(dashboardCounts.totalCollection)}
                            </label>
                          </div>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"col-xl-3 col-lg-6 col-12"}>
                  <div className="card bg_danger">
                    <div className="card-content">
                      <div className="card-body payment3 images_bg ">
                        <h4
                          className="text-white font24"
                          style={{ textDecoration: "none" }}
                        >
                          <img
                            src={paymentSmall_3}
                            className="card_small_img"
                            alt="Img"
                          />
                          <div className="tile_cards">
                            <span style={{ fontSize: "20px" }}>
                              Outstanding
                            </span>
                            <label>
                              {isEmployee ? "INR " : currency + " "}
                              {Object.keys(dashboardCounts).length > 0 &&
                                formatNumber(dashboardCounts.totalOutstanding)}
                            </label>
                          </div>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"col-xl-3 col-lg-6 col-12"}>
                  <div className="card  bg_success">
                    <div className="card-content">
                      <div className="card-body payment4 images_bg">
                        <h4 className="text-white font24">
                          <img
                            src={paymentSmall_4}
                            className="card_small_img"
                            alt="Img"
                          />
                          <div className="tile_cards">
                            <span style={{ fontSize: "20px" }}>
                              Total Overdue
                            </span>
                            <label>
                              {isEmployee ? "INR " : currency + " "}
                              {Object.keys(dashboardCounts).length > 0 &&
                                formatNumber(dashboardCounts.totalOverDue)}
                            </label>
                          </div>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Spin>
            <div className="row payment_tab payment_card1">
              <div className="col-md-10 col-sm-6 card_10">
                <div className="d-flex justify-content-between pb-30">
                  <label>Outstanding Analysis</label>
                  <span
                    className="reset_filter_spn"
                    onClick={handleResetFilterData}
                  >
                    Reset filter
                    <img src={imgFilter} alt="img" className="pb_5" />
                  </span>
                </div>
                <div className="d-flex" style={{ overflow: "auto" }}>
                  <div className="mr_12 mb-10 ">
                    <Select
                      mode="multiple"
                      value={selectedDistributionIds}
                      optionFilterProp="children"
                      placeholder="Select Distribution"
                      onChange={handleDistributionOnChange}
                      showSearch={true}
                      showArrow
                    >
                      <Option
                        key="all"
                        value="all"
                        label={
                          isSelectDistributionAll
                            ? "Deselect All"
                            : "Select All"
                        }
                      >
                        {isSelectDistributionAll
                          ? "Deselect All"
                          : "Select All"}
                      </Option>
                      {distributionChannelData.map((item, i) => {
                        return (
                          <Option value={item.id} key={i}>
                            {item.channel_Name ? item.channel_Name : "(Blank)"}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="mr_12 mb-10">
                    <Select
                      mode="multiple"
                      value={selectedCountryIds}
                      optionFilterProp="children"
                      placeholder="Select Country"
                      onChange={handleCountryOnChange}
                      showSearch={true}
                      showArrow
                    >
                      <Option
                        key="all"
                        value="all"
                        label={
                          isSelectCountryAll ? "Deselect All" : "Select All"
                        }
                      >
                        {isSelectCountryAll ? "Deselect All" : "Select All"}
                      </Option>
                      {countryData.map((item, i) => {
                        return (
                          <Option value={item.id} key={i}>
                            {item.name ? item.name : "(Blank)"}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="mr_12 mb-10">
                    <Select
                      mode="multiple"
                      value={selectedPriceGroupIds}
                      optionFilterProp="children"
                      placeholder="Select Price Group"
                      onChange={handlePriceGroupOnChange}
                      showSearch={true}
                      showArrow
                    >
                      <Option
                        key="all"
                        value="all"
                        label={
                          isSelectPriceGroupAll ? "Deselect All" : "Select All"
                        }
                      >
                        {isSelectPriceGroupAll ? "Deselect All" : "Select All"}
                      </Option>
                      {priceGroupData.map((item, i) => {
                        return (
                          <Option value={item.id} key={i}>
                            {item.group_Name ? item.group_Name : "(Blank)"}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                  <div className="mr_12 mb-10">
                    <Select
                      mode="multiple"
                      value={selectedSalesOfficeIds}
                      optionFilterProp="children"
                      placeholder="Select Sales Office"
                      onChange={handleSalesOfficeOnChange}
                      showSearch={true}
                      showArrow
                    >
                      <Option
                        key="all"
                        value="all"
                        label={
                          isSelectSalesOfficeAll ? "Deselect All" : "Select All"
                        }
                      >
                        {isSelectSalesOfficeAll ? "Deselect All" : "Select All"}
                      </Option>
                      {salesOfficeData.map((item, i) => {
                        return (
                          <Option value={item.id} key={i}>
                            {item.location ? item.location : "(Blank)"}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-sm-6 card_2">
                <div className="left_section_card">
                  <img src={imgBank} alt="img" />
                  <label className="count">
                    {isEmployee
                      ? "INR " + totalAmountLCYCount
                      : currency + " " + totalActualAmt}
                  </label>
                  <span>
                    {isEmployee ? "Total Outstanding LCY" : "Total Outstanding"}
                  </span>
                </div>
              </div>
            </div>
            <div className="row mt_18 payment_card1 ">
              <div className="col-md-10 card_chart payment_tab">
                <div className="dis_flex justify-content-between gap-3">
                  <div className="dis_flex flex-column flex-grow-1">
                  <div className="dis_flex">
                  <label className="pt-8 w-fit-content">
                    Invoice vs Outstanding Graph
                  </label>
                  <div className="pl-40 dis_flex invoice_out">
                    <Select
                      name="year"
                      optionFilterProp="children"
                      placeholder="Select Year"
                      value={selectYears}
                      onChange={(e) => handleDropDownOnChange(e, "year")}
                      showSearch={false}
                      showArrow
                    >
                      {yearsData.map((item, i) => {
                        return (
                          <Option value={item.year} key={i}>
                            {item.year}
                          </Option>
                        );
                      })}
                    </Select>
                    <Select
                      className="pl-20"
                      optionFilterProp="children"
                      placeholder="Select Quarter"
                      value={selectQuater}
                      onChange={(e) => handleDropDownOnChange(e, "Quater")}
                      showSearch={false}
                      showArrow
                    >
                      <Option key="all" value="all" label="Select All">
                        Select All
                      </Option>
                      <Option value={"1"}>Quarter 1</Option>
                      <Option value={"2"}>Quarter 2</Option>
                      <Option value={"3"}>Quarter 3</Option>
                      <Option value={"4"}>Quarter 4</Option>
                    </Select>
                  </div>
                  </div>
                  <div className="flex-grow-1 pt-20">
                    <InvoiceOutstandingBarChart
                      invoiceOutStandingData={invoiceOutStandingData}
                      customerOutstandingAvg={customerOutstandingAvg}
                      isOutStandingLoading={isOutStandingLoading}
                      currency={currency}
                      isEmployee={isEmployee}
                    />
                  </div>
                  </div>
                  <div>
                  <div className="dis_flex pb-20">
                  <div className="outstandingGraphTable pb-2 dis_flex  ">
                    <table className="custom-table">
                      <thead>
                        <tr>
                          <th colSpan={2}>Average Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Invoice</td>
                          <td>
                            {isEmployee ? "INR " : currency + " "}
                            {customerOutstandingAvg.avgTotalInvoice
                              ? formatNumber(
                                  customerOutstandingAvg.avgTotalInvoice
                                )
                              : "0"}
                          </td>
                        </tr>
                        <tr>
                          <td>{isEmployee ? "Collection" : "Payment"}</td>
                          <td>
                            {isEmployee ? "INR " : currency + " "}
                            {customerOutstandingAvg.avgTotalCollection
                              ? formatNumber(
                                  customerOutstandingAvg.avgTotalCollection
                                )
                              : "0"}
                          </td>
                        </tr>
                        <tr>
                          <td>Outstanding</td>
                          <td>
                            {isEmployee ? "INR " : currency + " "}
                            {customerOutstandingAvg.avgTotalOutstanding
                              ? formatNumber(
                                  customerOutstandingAvg.avgTotalOutstanding
                                )
                              : "0"}
                          </td>
                        </tr>
                        <tr>
                          <td>Credit Days Allotted</td>
                          <td>
                            {customerOutstandingAvg.creditdays_Alloted || "0"} Days
                          </td>
                        </tr>

                        <tr>
                          <td>Credit Days Utilized</td>
                          <td
                            className={
                              Number(customerOutstandingAvg.creditdays_Utilized || 0) >
                              Number(customerOutstandingAvg.creditdays_Alloted || 0)
                                ? "error_red"
                                : ""
                            }
                          >
                            {customerOutstandingAvg.creditdays_Utilized || "0"} Days
                          </td>
                        </tr>

                        <tr>
                          <td>Credit Limit Allotted</td>
                          <td>
                            {isEmployee ? "INR " : currency + " "}
                            {customerUtilization.totalCreditLimit_Alloted
                              ? formatNumber(customerUtilization.totalCreditLimit_Alloted)
                              : "0"}
                          </td>
                        </tr>

                        <tr>
                          <td>Credit Limit Utilized</td>
                          <td
                            className={
                              Number(customerUtilization.creditLimit_Utilized || 0) >
                              Number(customerUtilization.totalCreditLimit_Alloted || 0)
                                ? "error_red"
                                : ""
                            }
                          >
                            {isEmployee ? "INR " : currency + " "}
                            {customerUtilization.creditLimit_Utilized
                              ? formatNumber(customerUtilization.creditLimit_Utilized)
                              : "0"}
                          </td>
                        </tr>
                        <tr>
                          <td>No of Unadjusted Invoices</td>
                          <td>
                            {customerOutstandingAvg.total_UnadjustedInvoice
                              ?
                                customerOutstandingAvg.total_UnadjustedInvoice
                              : "0"} Invoices
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                </div>
                </div>
              </div>
            </div>
            <div className="pay_section_1">
              <div className="row payment_tab">
                <div className="col-md-3">
                  <label className="analy_type">Select Analysis Type</label>
                </div>
                <div className="col-md-9">
                  <Tabs
                    activeKey={selectAnalysisType}
                    className="tab_panel"
                    type="card"
                    onChange={handleAnalysisTypeChange}
                  >
                    <TabPane tab="Credit Days" key="C" />
                    <TabPane tab="Overdue" key="O" />
                    <TabPane tab="Planning Due Date" key="P" />
                    <TabPane tab="Total Days" key="T" />
                    <TabPane tab="Receivable Payment" key="R" />
                  </Tabs>
                </div>
              </div>
            </div>
            <Card className="pay_section_2">
              <div className="row">
                <div className="col-md-12">
                  <CustomerTab
                    selectAnalysisType={selectAnalysisType}
                    selectedDistributionIds={selectedDistributionIds}
                    selectedCountryIds={selectedCountryIds}
                    selectedPriceGroupIds={selectedPriceGroupIds}
                    selectedSalesOfficeIds={selectedSalesOfficeIds}
                    SelectedBarChartData={handleSetSelectedBarChartData}
                    isEmployee={userDetails.isEmployee}
                    applyFilterObj={applyFilterObj}
                    isReceivable={selectAnalysisType === "R"}
                  />
                </div>
              </div>
            </Card>
            <div className="pay_section_3">
              <div className="row payment_tab">
                <div className="col-md-4">
                  <label className="analy_type">Customer Aging Details</label>
                </div>
              </div>
            </div>
            <Card className="pay_section_2">
              <div className="row">
                <div className="col-md-12">
                  <CustomerAgingTbl
                    customerAgingData={customerAgingData}
                    customerAgingLoading={customerAgingLoading}
                    OnhandleTableSortColumn={handleTableSortColumn}
                    isEmployee={isEmployee}
                    currency={currency}
                    isReceivable={selectAnalysisType === "R"}
                  />
                </div>
              </div>
            </Card>
            <div className="pay_section_3">
              <div className="row payment_tab">
                <div className="col-md-4">
                  <label className="analy_type">Invoice Details</label>
                </div>
              </div>
            </div>
            <Card className="pay_section_2">
              <div className="row">
                <div className="col-md-12">
                  <InvoiceDetailsTbl
                    invoiceDetailsData={invoiceDetailsData}
                    isLoading={isLoading}
                    OnhandleTableSortColumn={handleTableSortColumn}
                    selectAnalysisType={selectAnalysisType}
                    selectedDistributionIds={selectedDistributionIds}
                    selectedCountryIds={selectedCountryIds}
                    selectedPriceGroupIds={selectedPriceGroupIds}
                    selectedSalesOfficeIds={selectedSalesOfficeIds}
                    isEmployee={isEmployee}
                    isReceivable={selectAnalysisType === "R"}
                  />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>

      <div className="main-filter">
        <GlobalFilterDrawer
          isGlobalFilter={isGlobalFilter}
          showFilterDrawer={showFilterDrawer}
          CloseFilterDrawer={CloseFilterDrawer}
          isEmployee={isEmployee}
          applyFilter={handleApplyFilter}
        />
      </div>
    </Fragment>
  );
};

export default PaymentDashboard;
